import { Directive, ElementRef, Input } from '@angular/core';

import { Alignment, Alignments, alignmentStyleClasses } from 'src/app/table-handling/types/aligments';

const styleAlignments = {
  [Alignments.CENTER]: ''
}

@Directive({
  selector: '[appAlign]',
  standalone: true,
})
export class AlignDirective {
  private static readonly ALIGNMENT_STYLES: string[] = Array.from(alignmentStyleClasses.values());

  @Input() public set appAlign(alignment: Alignment | undefined) {
    this.updateAlignment(alignment);
  }

  private alignment?: Alignment;

  constructor(private readonly element: ElementRef<HTMLElement>) {}

  private updateAlignment(alignment: Alignment | undefined): void {
    if (this.alignment === alignment) {
      return;
    }

    this.alignment = alignment;

    this.element.nativeElement.classList.remove(...AlignDirective.ALIGNMENT_STYLES);

    if (this.alignment) {
      this.element.nativeElement.classList.add(alignmentStyleClasses.get(alignment));
    }
  }
}

